"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useValue = initialValue => {
  const [value, setValue] = (0, _react.useState)(initialValue);
  const setTrue = (0, _react.useCallback)(() => setValue(true), []);
  const setFalse = (0, _react.useCallback)(() => setValue(false), []);
  const setNull = (0, _react.useCallback)(() => setValue(null), []);
  return (0, _react.useMemo)(() => {
    return {
      value,
      setValue,
      setTrue,
      setFalse,
      setNull
    };
  }, [value, setValue, setTrue, setFalse, setNull]);
};
var _default = exports.default = useValue;